// `display.changed` on `display:{stationId}` (ADR-0033; spec/09 §3, §6.3).
//
// A staff-run station's countdown screen re-reads `GET /v1/public/displays/{token}` when this arrives: a session
// started, ended, was given time, locked or unlocked, went into grace, or the screen's link was rotated or revoked.
// It carries **no data** — only "re-read" — so the REST read, which checks the link, stays the only source of what the
// screen shows, and a socket that outlives a revoke learns nothing.
import { z } from "../zod.js";
import { IsoDateTimeSchema } from "../primitives/scalars.js";
import { DISPLAY_CHANGED } from "./constants.js";
import { realtimeMessage } from "./envelope.js";
export { DISPLAY_CHANGED };
export const DisplayChangedPayloadSchema = z
    .object({
    /** When the change happened. */
    at: IsoDateTimeSchema,
})
    .openapi('DisplayChangedPayload', { description: 'A countdown screen should re-read what it shows (ADR-0033). Carries no data.' });
export const DisplayChangedMessage = realtimeMessage('evt', DISPLAY_CHANGED, DisplayChangedPayloadSchema, 'DisplayChangedMessage');
//# sourceMappingURL=display.js.map